export default __webpack_public_path__ + "static/media/access-security.2228b590.svg";